// extracted by mini-css-extract-plugin
export default {"container":"style_container__6Ew96","advertiser":"style_advertiser__py3ue","btn":"style_btn__m+TxN"};